import React from 'react'
import {FallbackProps} from 'react-error-boundary'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import FontsLoaderNext from '@vio/atlas/src/components/designSystem/helpers/FontsLoaderNext/FontsLoaderNext'
import {getBrandCodeFromUrlOrCookie} from '@vio/core/src/_web/brand/utils'
import {brands} from '@vio/core/src/brand/config'

import {CrashErrorMessageContainer, ErrorMessage} from '../CrashErrorMessage'

const HeightWrapper = styled.div`
  min-height: 600px;
  height: 1px;
`

interface Props extends FallbackProps {
  onClick?: () => void
  t?: ErrorMessage
}

export const ErrorBoundaryFallback: React.FC<Props> = ({onClick, t}) => {
  const {locale} = useIntl()
  const brand = getBrandCodeFromUrlOrCookie()

  return (
    <>
      <FontsLoaderNext languageCode={locale} theme={brands[brand].theme} />
      <HeightWrapper>
        <CrashErrorMessageContainer t={t} onClick={onClick} />
      </HeightWrapper>
    </>
  )
}
